/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PromptRecommendationFetchResponse {
    getFixupPrototypeFunction() { return PromptRecommendationFetchResponse.fixupPrototype; }

    static newInstance(model: Partial<PromptRecommendationFetchResponse>): PromptRecommendationFetchResponse {
        let obj = Object.assign(new PromptRecommendationFetchResponse(), model);
        PromptRecommendationFetchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PromptRecommendationFetchResponse>): PromptRecommendationFetchResponse {
        if (!model) return null;
        return PromptRecommendationFetchResponse.newInstance(<PromptRecommendationFetchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PromptRecommendationFetchResponse) {
        if (!obj) return;

        models.PromptRecommendationFetchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PromptRecommendationFetchResponse): boolean {
        Object.setPrototypeOf(obj, PromptRecommendationFetchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.recommendations) {
            for (let val of this.recommendations) {
                models.PromptRecommendationDetailItem.fixupPrototype(val);
            }
        }
    }

    /**
     * Same shape as the batch/list recommendation endpoints, scoped to this one prompt; present when the response status is 200
     */
    recommendations: Array<models.PromptRecommendationDetailItem>;

    /**
     * Explains an empty 'recommendations' list: present at 202 (still generating) and at 200 when generation finished but found nothing to recommend
     */
    message: string;

}
